import { formatDate, formatDateTime, formatNumber } from "./base_func";
import { mapState } from "vuex";

export let BaseDetailData = function() {
  return {
    props: {
      id: [Number, String],
      base_view_url: String,
      item_type: String
    },
    data() {
      return {
        loading: true,
        detail_id: this.id,
        detail: {
          // name: '',
          // created_date_display: '',
          // phone: '',
          // email: '',
          // address_legal: ''
        }
      };
    },
    computed: {
      display_edit_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_update_owner`
          ) !== -1
        );
      },
      display_delete_button() {
        let itemtype = this.item_type.replace("_", "");
        return (
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_all`
          ) !== -1 ||
          this.permissions.indexOf(
            `${this.item_type}.${itemtype}_delete_owner`
          ) !== -1
        );
      },

      display_store_link() {
        return (
          this.permissions.indexOf("store.store_detail_all") !== -1 ||
          this.permissions.indexOf("store.store_detail_owner") !== -1
        );
      },
      display_customer_link() {
        return (
          this.permissions.indexOf("customer.customer_detail_all") !== -1 ||
          this.permissions.indexOf("customer.customer_detail_owner") !== -1
        );
      },
      display_supplier_link() {
        return (
          this.permissions.indexOf("supplier.supplier_detail_all") !== -1 ||
          this.permissions.indexOf("supplier.supplier_detail_owner") !== -1
        );
      },
      display_money_order_link() {
        return (
          this.permissions.indexOf("money_order.moneyorder_detail_all") !==
            -1 ||
          this.permissions.indexOf("money_order.moneyorder_detail_owner") !== -1
        );
      },
      display_account_link() {
        return (
          this.permissions.indexOf("account.account_detail_all") !== -1 ||
          this.permissions.indexOf("account.account_detail_owner") !== -1
        );
      },
      display_user_link() {
        return (
          this.permissions.indexOf("user.user_detail_all") !== -1 ||
          this.permissions.indexOf("user.user_detail_owner") !== -1
        );
      },

      ...mapState([
        "user_id",
        "user_full_name",
        "current_view",
        "current_view_parent",
        "currency",
        "permissions",
        "role",
        "role_display",
        "use_fiscal",
        "company_name",
        "cashes"
      ])
    },
    methods: {
      fetchItem() {
        this.loading = true;

        const url = `${this.base_view_url}${this.detail_id}/`;
        this.$http
          .get(url)
          .then(result => {
            this.detail = result.data;
          })
          .finally(() => {
            this.loading = false;
          });
      },

      // User actions
      cancelAction() {
        this.showList();
      },
      editAction() {
        this.showEdit();
      },
      deleteAction() {

          const url = `${this.base_view_url}${this.detail_id}/`;
          this.loading = true;
          this.$http
            .delete(url)
            .then(response => {
              this.$Message.success("Успешно удалено");
              this.showList();
              this.$emit("reload_table");
            })
            .finally(() => {
              this.loading = false;
            });

      },

      // Роутинг
      showList() {
        this.$emit("click_cancel");
      },
      showEdit() {
        this.$emit("click_edit", this.detail_id);
      },

      // Изменение вида в соответствии с маршрутом
      initialRoute(route) {
        if (route.name === this.item_type) {
          this.showList();
        } else if (route.name === this.item_type + "_edit") {
          this.showEdit();
        } else if (route.name === this.item_type + "_create") {
          // !!! ПЕРЕДЕЛАТЬ !!!

          this.showList();
        } else if (route.name === this.item_type + "_detail") {
          this.detail_id = route.params.id;
          this.fetchItem();
        }
      },

      // Форматирование
      formatNumber(number) {
        return formatNumber(number);
      },
      formatDate(date) {
        return formatDate(date);
      },
      formatDateTime(datetime) {
        return formatDateTime(datetime);
      }
    },
    created() {
      this.fetchItem();
    },
    watch: {
      $route: function(to, from) {
        this.initialRoute(to);
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/base/base_detail_v2.js